import { getInvoicesUser } from ".";
import { IInvoiceUser } from "../models";

export const getInvoice = async ({ token }: { token: string }): Promise<IInvoiceUser[]> => {
  const res = await getInvoicesUser({ token });
  const dtoRes = res?.map((item: any): IInvoiceUser => {
    return {
      invoice: item.urlStatement,
      month: item.month,
      value: item.paymentAmount,
      timeApproved: item.timeApproved,
      year: item.year,
    };
  });
  return dtoRes;
};
